<template>
  <div>
    <div class="block" v-if="!hideDate">
      <div class="title-container">
        <h3 v-if="orderType == 'pickUp'">Afhalen</h3>
        <h3 v-else>Bezorging</h3>

        <button
          class="white-pill-s right-btn"
          v-if="!checkOutStore.deliveryAddressIncludedInFiles"
          @click="$emit('goTo')"
        >
          Bewerken
        </button>
      </div>

      <div v-if="printStoreOnly" class="ps-only">
        <label>Signing</label><span> max. 3 werkdagen </span>
      </div>
      <div v-else-if="checkOutStore.deliveryAddressIncludedInFiles">
        Zie productspecificaties voor bezorgdatum.
      </div>
      <div v-else>
        <span
          class="error-text pointer"
          @click="$emit('goTo')"
          v-if="!order.deliveryDate?.value && !hideErrors"
          >Datum ontbreekt nog, klik hier.</span
        >
        <span
          class="error-text pointer"
          @click="$emit('goTo')"
          v-else-if="isDateInPast && !hideErrors"
          >Bezorgdatum is verlopen, klik hier om een nieuwe datum te
          kiezen.</span
        >
        <span v-else-if="order.deliveryDate?.day == 'spoed'">
          Spoed
        </span>
        <span v-else class="capitalize">
          {{ order.deliveryDate?.day }} {{ deliveryDate }}
        </span>
        <p v-if="combiOrder">
          <label>Stickers & borden:</label><span> max. 3 werkdagen </span>
        </p>
      </div>
    </div>

    <div class="block" v-if="orderType == 'deliver'">
      <div class="title-container">
        <h3 class="system-text">
          Bezorgadres
        </h3>
        <button v-if="hideDate" class="white-pill-s" @click="$emit('goTo')">
          Bewerken
        </button>
      </div>
      <p v-if="checkOutStore.deliveryAddressIncludedInFiles">
        Zie adressenlijst
      </p>
      <p
        class="error-text pointer"
        v-else-if="!order.deliveryAddress.company && !hideErrors"
      >
        <span @click="$emit('goTo')"
          >Bezorgadres is niet compleet, klik hier.</span
        >
      </p>
      <p v-else>
        {{ order.deliveryAddress.company }}<br />
        <span
          class="error-text pointer"
          v-if="
            !order.deliveryAddress.department &&
            custom.department.required &&
            !hideErrors
          "
          @click="$emit('goTo')"
        >
          {{ custom.department.label ? custom.department.label : 'Afdeling' }}
          is verplicht, klik hier.<br />
        </span>
        <span
          class="error-text pointer"
          v-if="attentionOfMissing && !hideErrors"
          @click="$emit('goTo')"
        >
          T.a.v. is verplicht, klik hier.<br />
        </span>

        <span v-if="order.deliveryAddress.department"
          >{{ custom.department.label ? custom.department.label : 'Afdeling' }}
          {{ order.deliveryAddress.department }}<br
        /></span>
        <span v-if="order.deliveryAddress.name"
          >t.a.v. {{ order.deliveryAddress.name }}<br
        /></span>
        {{ order.deliveryAddress.street }}
        {{ order.deliveryAddress.number }}
        {{ order.deliveryAddress.addition }}<br />
        {{ order.deliveryAddress.zipCode }}
        {{ order.deliveryAddress.city }}
      </p>
    </div>
    <div class="block" v-else>
      <div class="title-container">
        <h3 class="system-text">
          Afhaaladres
        </h3>
      </div>
      <p
        class="error-text pointer"
        v-if="!order.deliveryAddress.company && !hideErrors"
      >
        <span @click="$emit('goTo')"
          >Afhaaladres ontbreekt nog, klik hier.</span
        >
      </p>
      <p v-else>
        {{ order.deliveryAddress.name }}<br />
        {{ order.deliveryAddress.street }}
        {{ order.deliveryAddress.number }}
        {{ order.deliveryAddress.addition }}<br />
        {{ order.deliveryAddress.zipCode }}
        {{ order.deliveryAddress.city }}<br />
        tel. {{ order.deliveryAddress.phone }}<br />
        {{ order.deliveryAddress.email }}
      </p>
    </div>

    <div class="block" v-if="order.letter && order.letter.length">
      <h3>Bericht voor {{ order.deliveryAddress.name }}</h3>
      <p>
        <span class="letter">{{ order.letter }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { format, startOfDay } from 'date-fns'
import { mapStores } from 'pinia'
import { useCheckOutStore } from '@/features/checkOut/CheckOut.store'

export default {
  props: {
    order: {},
    orderType: {},
    hideDate: {},
    combiOrder: {
      default: false
    },
    printStoreOnly: {
      default: false
    },
    addressList: {
      default: false
    },
    hideErrors: {
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapStores(useCheckOutStore),
    custom() {
      return this.rootStore.theme.customFields
    },
    deliveryDate() {
      if (this.hideDate || !this.order.deliveryDate?.value) return {}
      return format(new Date(this.order.deliveryDate.value), 'dd-MM-yyyy')
    },
    attentionOfMissing() {
      return (
        this.orderType == 'deliver' &&
        !!this.custom.addresses?.customAttentionOf &&
        !this.order.deliveryAddress.name?.trim()
      )
    },
    isDateInPast() {
      if (
        !this.order.deliveryDate?.value ||
        this.order.deliveryDate.title === 'spoed'
      ) {
        return false
      }
      const selectedDate = startOfDay(new Date(this.order.deliveryDate.value))
      const today = startOfDay(new Date())
      return selectedDate <= today
    }
  },
  created() {
    const custom = this.rootStore.theme.customFields
    if (
      custom.hideDeliverOptions ||
      this.checkOutStore.deliveryAddressIncludedInFiles
    ) {
      this.$emit('removeError', 'deliveryError')
    } else if (
      (!this.hideDate && !this.order.deliveryDate?.value) ||
      (!this.hideDate && this.isDateInPast) ||
      !this.order.deliveryAddress.company ||
      (!this.order.deliveryAddress.department &&
        custom.department.required &&
        this.orderType != 'pickUp') ||
      this.attentionOfMissing
    ) {
      this.$emit('addError', 'deliveryError')
    } else {
      this.$emit('removeError', 'deliveryError')
    }
  }
}
</script>

<style lang="scss" scoped>
.letter {
  white-space: pre-line;
}
</style>
